var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApply = function SvgApply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    className: "apply",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7F7",
    d: "M8.786 9.86a2.8 2.8 0 0 1 2.8-2.8h14.707a2.8 2.8 0 0 1 2.8 2.8v18.793a2.8 2.8 0 0 1-2.8 2.8H11.586a2.8 2.8 0 0 1-2.8-2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7F7",
    d: "M18.124 11.328c0 4.272-3.306 7.736-7.383 7.736S3.36 15.6 3.36 11.328s3.305-7.736 7.382-7.736 7.383 3.463 7.383 7.736Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "teal",
    fillRule: "evenodd",
    d: "M23.158 5.124H8.45a1.38 1.38 0 0 0-1.38 1.38v18.793c0 .762.618 1.38 1.38 1.38h14.707a1.38 1.38 0 0 0 1.38-1.38V6.504a1.38 1.38 0 0 0-1.38-1.38ZM8.45 3.704a2.8 2.8 0 0 0-2.8 2.8v18.793a2.8 2.8 0 0 0 2.8 2.8h14.707a2.8 2.8 0 0 0 2.8-2.8V6.504a2.8 2.8 0 0 0-2.8-2.8z",
    className: "icon-teal",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "teal",
    d: "M9.156 22.195a.73.73 0 0 1 .73-.73h6.524a.73.73 0 1 1 0 1.461H9.887a.73.73 0 0 1-.73-.731Zm0-4.01a.73.73 0 0 1 .73-.73H20.83a.73.73 0 1 1 0 1.461H9.887a.73.73 0 0 1-.73-.731Zm-2.807-4.01a.73.73 0 0 1 .73-.73h11.865a.73.73 0 0 1 0 1.461H7.08a.73.73 0 0 1-.73-.73Zm2.807-4.01a.73.73 0 0 1 .73-.73h11.836a.73.73 0 0 1 0 1.461H9.887a.73.73 0 0 1-.73-.73Z",
    className: "icon-teal"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.766 7.873a6.984 6.984 0 1 1-13.966 0 6.984 6.984 0 1 1 13.966 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "teal",
    fillRule: "evenodd",
    d: "M7.783 13.438a5.564 5.564 0 0 0 5.563-5.565 5.564 5.564 0 1 0-5.563 5.565m0 1.42a6.984 6.984 0 0 0 6.983-6.985 6.984 6.984 0 1 0-13.966 0 6.984 6.984 0 0 0 6.983 6.985",
    className: "icon-teal",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "teal",
    d: "M10.144 7.149c.265-.341.237-.836-.059-1.115a.75.75 0 0 0-1.064.062l-1.83 2.198-.887-.929a.725.725 0 0 0-1.063 0 .81.81 0 0 0 0 1.115l1.446 1.516a.7.7 0 0 0 .532.216h.03a.63.63 0 0 0 .532-.278z",
    className: "icon-teal"
  })));
};
export default SvgApply;